var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-form",
    {
      attrs: { form: _vm.form },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.handleSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "a-form-item",
        { attrs: { label: _vm.$t("modules.type") } },
        [
          _c(
            "a-select",
            {
              model: {
                value: _vm.form.type,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "type", $$v)
                },
                expression: "form.type",
              },
            },
            [
              _c("a-select-option", { attrs: { value: "module" } }, [
                _vm._v(_vm._s(_vm.$t("modules.module"))),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "relation" } }, [
                _vm._v(_vm._s(_vm.$t("modules.relation"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-form-item",
        { attrs: { label: _vm.$t("modules.moduleRelationName") } },
        [
          _c("a-input", {
            model: {
              value: _vm.form.displayName,
              callback: function ($$v) {
                _vm.$set(_vm.form, "displayName", $$v)
              },
              expression: "form.displayName",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-form-item",
        { attrs: { label: _vm.$t("modules.moduleRelationTable") } },
        [
          _c(
            "a-select",
            {
              model: {
                value: _vm.form.table,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "table", $$v)
                },
                expression: "form.table",
              },
            },
            _vm._l(_vm.tables, function (table) {
              return _c(
                "a-select-option",
                { key: table._id, attrs: { value: table._id } },
                [
                  _vm._v(
                    "\n                " + _vm._s(table.name) + "\n            "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.form.type === "relation"
        ? _c(
            "a-collapse",
            [
              _c(
                "a-collapse-panel",
                {
                  key: "1",
                  attrs: { header: _vm.$t("modules.relationSettings") },
                },
                [
                  _vm.form.table
                    ? _c(
                        "a-form-item",
                        { attrs: { label: _vm.$t("modules.remoteField") } },
                        [
                          _c(
                            "a-select",
                            {
                              model: {
                                value: _vm.form.relation.remoteField,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form.relation,
                                    "remoteField",
                                    $$v
                                  )
                                },
                                expression: "form.relation.remoteField",
                              },
                            },
                            _vm._l(
                              _vm.getTableFields(_vm.form.table, true),
                              function (field) {
                                return _c(
                                  "a-select-option",
                                  {
                                    key: field._id,
                                    attrs: { value: field._id },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(field.name) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: _vm.$t("modules.relationType") } },
                    [
                      _c(
                        "a-select",
                        {
                          on: { change: _vm.handleModuleTypeChange },
                          model: {
                            value: _vm.form.relation.moduleType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.relation, "moduleType", $$v)
                            },
                            expression: "form.relation.moduleType",
                          },
                        },
                        [
                          _c(
                            "a-select-option",
                            { attrs: { value: "standart" } },
                            [_vm._v(_vm._s(_vm.$t("modules.standartModule")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-select-option",
                            { attrs: { value: "custom" } },
                            [_vm._v(_vm._s(_vm.$t("modules.customTable")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.relation.moduleType === "standart"
                    ? _c(
                        "a-form-item",
                        { attrs: { label: _vm.$t("modules.standartModule") } },
                        [
                          _c(
                            "a-select",
                            {
                              model: {
                                value: _vm.form.relation.module,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form.relation, "module", $$v)
                                },
                                expression: "form.relation.module",
                              },
                            },
                            [
                              _c(
                                "a-select-option",
                                { attrs: { value: "contact" } },
                                [_vm._v(_vm._s(_vm.$t("modules.contact")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.relation.moduleType === "custom"
                    ? _c(
                        "a-form-item",
                        { attrs: { label: _vm.$t("modules.customTable") } },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "a-select",
                                {
                                  model: {
                                    value: _vm.form.relation.module,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form.relation, "module", $$v)
                                    },
                                    expression: "form.relation.module",
                                  },
                                },
                                _vm._l(_vm.tables, function (table) {
                                  return _c(
                                    "a-select-option",
                                    {
                                      key: table._id,
                                      attrs: { value: table._id },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(table.name) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _vm.form.relation.module
                                ? _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("modules.localField"),
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          model: {
                                            value:
                                              _vm.form.relation.custom
                                                .localField,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form.relation.custom,
                                                "localField",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.relation.custom.localField",
                                          },
                                        },
                                        _vm._l(
                                          _vm.getTableFields(
                                            _vm.form.relation.module,
                                            true
                                          ),
                                          function (field) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: field._id,
                                                attrs: { value: field._id },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(field.name) +
                                                    "\n                            "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.relation.moduleType === "standart"
                    ? _c(
                        "div",
                        { staticStyle: { display: "flex", gap: "16px" } },
                        [
                          _c(
                            "a-form-item",
                            {
                              staticStyle: { flex: "1" },
                              attrs: {
                                label: _vm.$t("modules.localFieldType"),
                              },
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  model: {
                                    value:
                                      _vm.form.relation.standart.localFieldType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.relation.standart,
                                        "localFieldType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.relation.standart.localFieldType",
                                  },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "standart" } },
                                    [_vm._v(_vm._s(_vm.$t("modules.standart")))]
                                  ),
                                  _vm._v(" "),
                                  _vm.form.relation.module === "contact"
                                    ? _c(
                                        "a-select-option",
                                        { attrs: { value: "custom" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("modules.custom"))
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.form.relation.standart.localFieldType ===
                          "standart"
                            ? _c(
                                "a-form-item",
                                {
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    label: _vm.$t("modules.localField"),
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      model: {
                                        value:
                                          _vm.form.relation.standart.localField,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.relation.standart,
                                            "localField",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.relation.standart.localField",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "_id" } },
                                        [_vm._v("_id")]
                                      ),
                                      _vm._v(" "),
                                      _vm.form.relation.module === "contact"
                                        ? _c(
                                            "a-select-option",
                                            {
                                              attrs: {
                                                value: "whatsappNumber",
                                              },
                                            },
                                            [_vm._v("whatsappNumber")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.form.relation.module === "contact"
                                        ? _c(
                                            "a-select-option",
                                            { attrs: { value: "email" } },
                                            [_vm._v("email")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.relation.standart.localFieldType === "custom"
                            ? _c(
                                "a-form-item",
                                {
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    label: _vm.$t("modules.localField"),
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      model: {
                                        value:
                                          _vm.form.relation.standart.localField,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.relation.standart,
                                            "localField",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.relation.standart.localField",
                                      },
                                    },
                                    _vm._l(
                                      _vm.contactProperties,
                                      function (prop) {
                                        return _c(
                                          "a-select-option",
                                          {
                                            key: prop._id,
                                            attrs: { value: prop._id },
                                          },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(prop.label) +
                                                "\n                        "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.table
                    ? _c(
                        "a-form-item",
                        {
                          staticStyle: { flex: "1" },
                          attrs: {
                            label: _vm.$t("modules.showingRemoteFieldInList"),
                          },
                        },
                        [
                          _c(
                            "a-select",
                            {
                              model: {
                                value:
                                  _vm.form.relation.showingRemoteFieldInList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form.relation,
                                    "showingRemoteFieldInList",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.relation.showingRemoteFieldInList",
                              },
                            },
                            _vm._l(
                              _vm.getTableFields(_vm.form.table),
                              function (field) {
                                return _c(
                                  "a-select-option",
                                  {
                                    key: field._id,
                                    attrs: { value: field._id },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(field.name) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-form-item",
        { attrs: { label: _vm.$t("modules.settings") } },
        [
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.form.settings.showInMainMenu,
                callback: function ($$v) {
                  _vm.$set(_vm.form.settings, "showInMainMenu", $$v)
                },
                expression: "form.settings.showInMainMenu",
              },
            },
            [_vm._v(_vm._s(_vm.$t("modules.showInMainMenu")))]
          ),
          _vm._v(" "),
          _c(
            "a-checkbox",
            {
              model: {
                value: _vm.form.settings.apiEnabled,
                callback: function ($$v) {
                  _vm.$set(_vm.form.settings, "apiEnabled", $$v)
                },
                expression: "form.settings.apiEnabled",
              },
            },
            [_vm._v(_vm._s(_vm.$t("modules.apiEnabled")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-form-item",
        { attrs: { label: _vm.$t("modules.icon") } },
        [
          _c("a-input", {
            model: {
              value: _vm.form.icon,
              callback: function ($$v) {
                _vm.$set(_vm.form, "icon", $$v)
              },
              expression: "form.icon",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-form-item",
        [
          _c(
            "a-button",
            { attrs: { type: "primary", "html-type": "submit" } },
            [_vm._v(_vm._s(_vm.$t("modules.createModule")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }